import React from 'react'

export const CommonContent = (props) => {
  const string = props.stringToRet;

  return (
    <>
      {(string === 'address') && (
        <>Via San Vittore 21, Milano<br />
        Tel 02 48 555 1  ·  Fax 02 48 0100 16 <br /></>
      )}
    </>
  )
}
